import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import WelcomeHeader from '../components/layout/WelcomeHeader';
import styles from './InfoPage.module.css';
import { contactApi } from '../api';

function Contact({ loggedIn, username }) {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsSending(true);

    try {
      const result = await contactApi.sendMessage(formData);
      if (result.success) {
        setSubmitted(true);
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else if (result.error?.code === 'MAIL_DELIVERY_FAILED') {
        setError(t('contact.errMailDelivery'));
      } else if (result.error?.code === 'VALIDATION_ERROR') {
        const details = result.error?.details;
        const detailText = details && Object.keys(details).length > 0
          ? Object.values(details).join(' ')
          : t('contact.errValidationDefault');
        setError(`${t('contact.errValidationPrefix')} ${detailText}`);
      } else {
        setError(result.error?.message || t('contact.errGeneric'));
      }
    } catch (err) {
      setError(t('contact.errNetwork'));
    } finally {
      setIsSending(false);
    }
  };

  return (
    <>
      <WelcomeHeader loggedIn={loggedIn} username={username} />
      <div className={styles.pageContainer}>
        <div className={styles.contentWrapper}>
          <h1 className={styles.pageTitle}>{t('contact.title')}</h1>
          <div className={styles.content}>
            <p>{t('contact.intro')}</p>

            <form className={styles.contactForm} onSubmit={handleSubmit}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>{t('contact.name')}</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className={styles.formInput}
                  placeholder={t('contact.namePlaceholder')}
                  maxLength={100}
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel}>{t('contact.email')}</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className={styles.formInput}
                  placeholder={t('contact.emailPlaceholder')}
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel}>{t('contact.subject')}</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className={styles.formInput}
                  placeholder={t('contact.subjectPlaceholder')}
                  maxLength={200}
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel}>{t('contact.message')}</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className={styles.formTextarea}
                  placeholder={t('contact.messagePlaceholder')}
                  minLength={10}
                  maxLength={5000}
                  required
                />
                <span className={styles.formHint}>{t('contact.charCount', { count: formData.message.length })}</span>
              </div>

              {error && (
                <div style={{marginBottom:'1rem',padding:'0.75rem 1rem',background:'rgba(239,68,68,.1)',border:'1px solid rgba(239,68,68,.3)',borderRadius:'8px',color:'#f87171'}}>
                  ⚠️ {error}
                </div>
              )}

              <button type="submit" className={styles.submitButton} disabled={isSending}>
                {isSending ? t('contact.sending') : t('contact.send')}
              </button>
            </form>

            {submitted && (
              <div style={{marginTop:'1rem',padding:'0.75rem 1rem',background:'rgba(16,185,129,.1)',border:'1px solid rgba(16,185,129,.3)',borderRadius:'8px',color:'#34d399'}}>
                {t('contact.sent')}
              </div>
            )}

            <h2>{t('contact.otherWays')}</h2>
            <p>
              <strong>GitHub:</strong> <a href="https://github.com/KilianJATO/MangaOrganisation" target="_blank" rel="noopener noreferrer">{t('contact.githubIssue')}</a><br />
              <strong>Email:</strong> support@mangashelf.app
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
